<template>
  <div>
    <ReportItemContainer v-if="isReportMode">
      <template #question>{{ question.text }}</template>
      <template #answer>
        <p>
          <span class="report-item-container__label">Name:</span>
          {{ person.name }}
        </p>
        <p>
          <span class="report-item-container__label">Surname:</span>
          {{ person.surname }}
        </p>
        <p>
          <span class="report-item-container__label">Date of Birth:</span>
          {{ person.birth }}
        </p>
        <p>
          <span class="report-item-container__label">Nationality:</span>
          {{ person.nationality }}
        </p>
        <p>
          <span class="report-item-container__label">Postition:</span>
          {{ person.position }}
        </p>
      </template>
    </ReportItemContainer>
    <div v-else class="mb-5">
      <p class="mb-5" v-if="question.text">
        {{ question.text }}
      </p>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <PInputField
            label="Name"
            :value="person.name"
            @updateEvent="
              (val) => {
                person.name = val;
                emitNewPerson();
              }
            "
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <PInputField
            label="Surname"
            :value="person.surname"
            @updateEvent="
              (val) => {
                person.surname = val;
                emitNewPerson();
              }
            "
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <p>Date of birth</p>
          <DateInput
            :value="person.birth"
            @valid="(val) => emitValid(val, 'DateOfBirth')"
            @update-event="
              (val) => {
                person.birth = val;
                emitNewPerson();
              }
            "
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <p>Nationality</p>
          <PAutocomplete
            :items="nationalities"
            :select-text="person.nationality"
            :placeholder="question.placeholder"
            @field-updated="(val: string) => { (person.nationality = val); emitNewPerson() }"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <PInputField
            label="Position in company"
            :value="person.position"
            @updateEvent="
              (val) => {
                person.position = val;
                emitNewPerson();
              }
            "
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import DateInput from "@/components/custom/DateInput.vue";
import ReportItemContainer from "@/components/containers/ReportItemContainer.vue";
import { nationalities } from "@/modules/nationalities";
import type { QuestionModelDto } from "@/models/dto/questionModelDto";
import PInputField from "@/components/custom/PInputField.vue";
import PAutocomplete from "@/components/custom/PAutocomplete.vue";
import { ConsentPerson } from "@/models/persons/consentPerson";

const props = withDefaults(
  defineProps<{
    questionModel: QuestionModelDto;
    answer?: ConsentPerson | null;
    isReportMode?: boolean;
  }>(),
  {
    isReportMode: false,
  }
);

const emit = defineEmits<{
  (e: "qEvent", newPerson: ConsentPerson): void;
  (e: "isValid", isValid: boolean, invalidField: string): void;
}>();

const person = ref(new ConsentPerson(props.answer));
const question = computed(() => props.questionModel.question);

function emitNewPerson(): void {
  emit("qEvent", person.value);
}

function emitValid(isValid: boolean, fieldId: string): void {
  emit("isValid", isValid, `${question.value.id}__${fieldId}`);
}
</script>
